import { useState } from "react";
import { ButtonGroup, Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { Href, LargeButton } from "../../../../Constants/Constants";

const LargeDropdown = () => {
  const [open, setOpen] = useState(false);
  return (
    <ButtonGroup>
      <Dropdown isOpen={open} toggle={() => setOpen(!open)} direction="down">
        <DropdownToggle caret color="dark" className="light text-white" size="lg">{LargeButton}</DropdownToggle>
        <DropdownMenu className="dropdown-block">
          <DropdownItem href={Href}>{"Small button"}</DropdownItem>
          <DropdownItem href={Href}>{"Medium button"}</DropdownItem>
          <DropdownItem href={Href}>{"Large button"}</DropdownItem>
          <DropdownItem href={Href} divider></DropdownItem>
          <DropdownItem href={Href}>{"Very large button"}</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </ButtonGroup>
  );
};
export default LargeDropdown;
